import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Header, Icon, Input } from 'semantic-ui-react';

import ListViewTable from './ListViewTable';

const ListView = (props) => {
  const { count, match, pluralName, singularName, ...rest } = props;
  return (
    <React.Fragment>
      <Header as="h2">
        {pluralName}
        <Header.Subheader>All {pluralName} ({count})</Header.Subheader>
      </Header>
      <Input icon="search" placeholder="Search" />
      <Button as={Link} to={`${match.url}/new`} primary floated="right" icon labelPosition="left">
        <Icon name="plus" />
        New {singularName}
      </Button>

      <ListViewTable {...rest} />
    </React.Fragment>
  );
};

export default ListView;
